import { render } from "./featherIcons.vue?vue&type=template&id=9a23615a"
import script from "./featherIcons.vue?vue&type=script&lang=js"
export * from "./featherIcons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__